import React, { useState, useEffect } from "react";
import { auth, db } from "../../firebase-config.js";
import { collection, addDoc, doc, deleteDoc, where, serverTimestamp, onSnapshot, query, orderBy } from "firebase/firestore";
import Cookies from "universal-cookie";
import { Box, Typography } from '@mui/material';
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import './styles.css'; // Import the new CSS file

const cookies = new Cookies();

function Billing() {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const messagesRef = collection(db, "messages");
  const roomasstring = "Atlético Madrid";

  useEffect(() => {
    const queryMessages = query(messagesRef, where("room", "==", roomasstring), orderBy("createdAt"));
    const unsubscribe = onSnapshot(queryMessages, (snapshot) => {
      const messages = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setMessages(messages);
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (newMessage === "") return;
    await addDoc(messagesRef, {
      text: newMessage,
      createdAt: serverTimestamp(),
      user: auth.currentUser.displayName,
      room: roomasstring,
      mid: cookies.get("auth-token1")?.userid,
      pro: cookies.get("auth-token1")?.photoURL
    });
    setNewMessage("");
  };

  const handleDelete = async (messageId) => {
    try {
      const messageDocRef = doc(db, "messages", messageId);
      await deleteDoc(messageDocRef);
    } catch (error) {
      console.error("Error deleting message: ", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={0}>
        {cookies.get('auth-token1') ? (
          <div className="chat-container">
            <div className="chat-box">
              <Box className="messages">
                {messages.map((message) => (
                  <Box
                    key={message.id}
                    className={`message ${message.mid === cookies.get('auth-token1').userid ? 'user-message' : 'other-message'}`}
                  >
                    {message.mid !== cookies.get('auth-token1').userid && (
                      <img src={message.pro} alt="User" />
                    )}
                    <Typography
                      variant="body1"
                      className="message-content"
                    >
                      <span>
                        {message.text}
                      </span>
                    </Typography>
                  </Box>
                ))}
              </Box>

            </div>
            <form onSubmit={handleSubmit} className="new-message-form">
              <input
                type="text"
                value={newMessage}
                onChange={(event) => setNewMessage(event.target.value)}
                className="new-message-input"
                placeholder="Type your message here..."
              />
              <button type="submit" className="send-button">
                Send
              </button>
            </form>
          </div>
        ) : (
          <h1 style={{ textAlign: "center" }}>SIGN IN FIRST</h1>
        )}
      </MDBox>
    </DashboardLayout>
  );
}

export default Billing;
